'use strict';

/**
 * This directive when added to a scroll area will add a gradient to the left
 * and right of the scroll area when not at their maximum.
 */
const ScrollFadeHorizontalDir = {
    bind: function (el, binding) {
        const opts = Object.assign({
            left    : true,
            right   : true
        }, binding.value || {});

        const showLeftFade = (element) => element.scrollLeft !== 0;
        const showRightFade = (element) => element.scrollWidth - element.scrollLeft !== element.clientWidth;

        el.addEventListener('scroll', (event) => {
            const element = event.target;
            element.classList.remove('el-scroll-fade-horizontal', 'el-scroll-fade-left', 'el-scroll-fade-right');

            const showLeft = opts.left && showLeftFade(element);
            const showRight = opts.right && showRightFade(element);

            //  An element can have only one mask, so we need to check which class to add
            if (showLeft && showRight) {
                element.classList.add('el-scroll-fade-horizontal');
            } else if (showLeft) {
                element.classList.add('el-scroll-fade-left');
            } else if (showRight) {
                element.classList.add('el-scroll-fade-right');
            }
        });

        //  Check on element load if we should display fade at the right
        if (showRightFade(el)) {
            el.classList.add('el-scroll-fade-right');
        }

        //  We use the resize observer because the list might be populated by ajax call
        if (opts.bottom) {
            const resizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    if (showRightFade(entry.target)) {
                        entry.target.classList.add('el-scroll-fade-right');
                    }
                }
                resizeObserver.unobserve(el)
            });

            resizeObserver.observe(el);
        }
    },
    unbind: function () {},
};

/**
 * Bind the scroll fade horizontal directive to Vue.
 * use with `v-ath-scroll-fade-horizontal` or `v-mead-scroll-fade-horizontal`.
 * The `v-ath-scroll-fade-horizontal` version is deprecated; use `v-mead-scroll-fade-horizontal` instead.
 */
const ScrollFadeHorizontalDirective = {
    /**
     * Bind the scroll fade horizontal directive to Vue.
     * use with `v-ath-scroll-fade-horizontal` or `v-mead-scroll-fade-horizontal`.
     * The `v-ath-scroll-fade-horizontal` version is deprecated; use `v-mead-scroll-fade-horizontal` instead.
     */
    bind: function (vue) {
        vue.directive('athScrollFadeHorizontal', ScrollFadeHorizontalDir);
        vue.directive('meadScrollFadeHorizontal', ScrollFadeHorizontalDir);
    }
}

export default ScrollFadeHorizontalDirective;
